import React from 'react';

function TextError(props) {
  return (
    <div style={{ color: '#E22E2E', marginLeft: '0.5em' }}>
      {props.children}
    </div>
  );
}

export default TextError;
